import React from "react";
import { useTranslation } from "react-i18next";

import CornerstonePage from "@/components/landing/CornerstonePage";
import { getCornerstone, getCornerstoneUi } from "@/data/cornerstones";
import { buildCornerstoneConfig } from "@/data/cornerstones/buildConfig";

const PATH = "/trainer-app-paard";

export const TrainerAppPaard = () => {
  const { i18n } = useTranslation();
  const data = getCornerstone("trainer", i18n.language);
  const ui = getCornerstoneUi(i18n.language);
  const config = buildCornerstoneConfig(PATH, data);
  return <CornerstonePage config={config} ui={ui} />;
};

export default TrainerAppPaard;
